import * as React from 'react'

import { inject, observer } from 'mobx-react'

import NavBar from '~/client/src/desktop/components/NavBar/NavBar'
import { Resource } from '~/client/src/desktop/components/Resource'
import DesktopInitialState from '~/client/src/desktop/stores/DesktopInitialState'
import * as Layout from '~/client/src/shared/components/Layout'
import Localization from '~/client/src/shared/localization/LocalizationManager'

import ProjectSetUp from '../ProjectSetUp/ProjectSetUp'
import { MaterialResourcesProvider } from './MaterialResourcesProvider'

interface MaterialResourcesProps {
  state?: DesktopInitialState
}

const MaterialResources: React.FC<MaterialResourcesProps> = ({ state }) => {
  const projectId = state?.activeProject?.id
  const userId = state?.user?.id

  if (!projectId || !userId || !state) {
    return null
  }

  return (
    <Layout.View className="material-resources">
      <Layout.Header className="layout-navigation">
        <NavBar />
      </Layout.Header>
      <Layout.Content className="tw:relative tw:overflow-hidden">
        <div className="tw:flex tw:items-center tw:h-full">
          <ProjectSetUp
            className="tw:flex tw:flex-col tw:h-full tw:max-w-fit"
            sidebarOnly
          />
          <div className="tw:flex tw:flex-1 tw:flex-col tw:h-full tw:min-w-0">
            <MaterialResourcesProvider
              projectId={projectId}
              userId={userId}
              state={state}
            >
              <Layout.View>
                <Layout.Header>
                  <Resource.TopBar>
                    <Resource.SavedViews projectId={projectId} />
                  </Resource.TopBar>
                  <Resource.Header>
                    <Resource.Search />
                    <Resource.Separator />
                    <Resource.Filters />
                    <Resource.Actions>
                      <Resource.DisplayOptions />
                    </Resource.Actions>
                  </Resource.Header>
                </Layout.Header>
                <Layout.Content>
                  <Resource.Content>
                    <Resource.ActionBar>
                      <div className="tw:flex tw:items-center tw:gap-2">
                        <Resource.CollapseToggle />
                        <Resource.RecordCount
                          label={c => Localization.translator.xMaterials(c)}
                        />
                        <Resource.DeleteButton
                          confirmationLabel={c =>
                            Localization.translator.confirmDeletionOfMaterials(
                              c,
                            )
                          }
                        />
                        <Resource.BulkEditButton />
                      </div>
                      <Resource.CreateButton />
                    </Resource.ActionBar>
                    <Resource.Table />
                  </Resource.Content>
                </Layout.Content>
              </Layout.View>
              <Resource.EditPanel />
              <Resource.BulkEditPanel />
            </MaterialResourcesProvider>
          </div>
        </div>
      </Layout.Content>
      <Layout.Footer>
        <div />
      </Layout.Footer>
    </Layout.View>
  )
}

export default inject('state')(observer(MaterialResources))
